export enum ApplicationAlert {
  EMAIL_CONFIRMATION,
  UPSELL,
  TRIAL_EXPIRED,
  PAST_DUE,
}
